angular.module('jv.Admin.Users.AccessGroups.controller', [])
    .controller('AdminUsersAccessGroupsCtrl', ['$scope', '$route',
        function ($scope, $route) {
            $scope.translations = i18n;
            $scope.flags.loading = false;
            $scope.validateODSFlag = $route.current.locals.accessGroupRedirect;
        }
    ]);